import React from 'react';

import Cards from '../Cards';
import { withEditable } from '../../../HOCs/withEditable';
import { withTrekEditInfo } from '../../../HOCs/withTrekEditInfo';
import withTrekPermission from '../../../HOCs/withTrekPermission';

const ServiceModalCards = props => <Cards {...props} />;

export default withEditable(withTrekPermission(withTrekEditInfo(ServiceModalCards)));



// WEBPACK FOOTER //
// ./src/screens/Trek/ServiceModal/ServiceModalCards.js